import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext'
import MenuBar from '../layouts/MenuBar';
import { Link } from 'react-router-dom';
import { ref, remove, set } from "firebase/database";
import app, { rtdb } from '../firebase';
import { postSettingsToDatabase } from '../features/Settings/postSettingsToDatabase';
import { useDatabase } from '../contexts/DatabaseContext';
import CarSettings from './components/CarSettings';
import { useTelemetry } from '../contexts/TelemetryContext';

export default function Settings() {

  // Firebase
  const { currentUser, updatedisplayname } = useAuth()
  const { carsSettings, userSettings } = useDatabase()
  const {clearRealtimeDatabase} = useTelemetry()

  const [userFormSettings, setUserFormSettings] = useState();
  const [carsFormSettings, setCarsFormSettings] = useState();

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const [loading, setLoading] = useState(false)

  const [currentTab, setCurrentTab] = useState(window.location.href.split('?')[1] || '0')

  useEffect(()=> {
    console.log(carsSettings)
    if (carsSettings != undefined) {
      setCarsFormSettings(carsSettings)
    }
  },[carsSettings])

  useEffect(()=> {
    console.log(userSettings)
    if (userSettings != undefined) {
      setUserFormSettings(userSettings)
    }
  },[userSettings])

  // UI functions
  // Determine if a tab should be hidden or not
  function determineHide(tab) {
    if (tab === parseInt(currentTab)) {
      return false
    } else {
      return true
    }
  }

  // Determine if a tab has the active class
  function determineActive(tab) {
    if (tab === parseInt(currentTab)) {
      return 'active'
    } else {
      return ''
    }
  }

  // Change tab when clicked
  function changeTab(e) {
    if (e.target.value) {
      setCurrentTab(e.target.value)
    } else {
      setCurrentTab(e.target.parentElement.getAttribute('data-value'))
    }
  }

  // Hide popup alerts
  function hideAlerts() {
    setError('')
    setSuccess('')
  }

  const handleAccountChange = (e) => {
    const { name, value } = e.target;
    setUserFormSettings({ ...userFormSettings, [name]: value })
  }







  return (
    <>
      <MenuBar />

      <div className="d-flex flex-column justify-content-between text-center mb-5 configure-dash">
        <div className="text-center mx-1 btn-group" role="group" aria-label="Settings Tab">
          <button value="0" className={"btn btn-secondary col-3 " + determineActive(0)} onClick={changeTab}>Account</button>

          <button value="1" className={"btn btn-secondary col-3 " + determineActive(1)} onClick={changeTab}>Cars</button>

          <button value="2" className={"btn btn-secondary col-3 " + determineActive(2)} onClick={changeTab}>Data</button>
        </div>

        <h1 className="pt-2 pb-3">Settings</h1>


        {error && <p onClick={hideAlerts} className="alert alert-danger">{error}</p>}
        {success && <p onClick={hideAlerts} className="alert alert-success">{success}</p>}

        <form>

          <div className="tab mx-1" hidden={determineHide(0)}>
            <h3>Account</h3>
            <div className="form-group my-3">
              <label htmlFor="team_name">Team Name</label>
              <input
                type="text"
                className="form-control"
                name="team_name"
                value={userFormSettings?.team_name || ''}
                onChange={handleAccountChange}
                placeholder="Team Name"
              />
            </div>


            <hr></hr>
            <Link to="/reset-password" className="btn btn-outline-dark btn-block">
              Reset Password
            </Link>
            <Link to="/logout" className="btn btn-outline-dark btn-block my-2">
              Logout
            </Link>

            <div className="border-top mt-2">
              <h3 className="mt-2">DashOwl</h3>
              <a href="https://www.vis.dashowl.co.uk" className="btn btn-outline-dark btn-block">eChook Logfile Visualiser</a>
            </div>
          </div>

          <div className="tab mx-1" hidden={determineHide(1)}>
            <h3>Cars</h3>

            {carsSettings ? carsSettings.map((car, index) => (
                <CarSettings car={car} index={index} />
              
            )) : <p>No cars found</p>}
          </div>

          <div className="tab mx-1" hidden={determineHide(2)}>
            <h3>Race</h3>
            <div className="form-group my-3">
              <label htmlFor="race_length">Race Length (mins)</label>
              <input
                type="number"
                className="form-control"
                name="race_length"
                value={userFormSettings?.race_length || 90}
                onChange={handleAccountChange}
                placeholder="90"
              />
            </div>

            <div className="form-group my-3">
              <label htmlFor="track_length">Manual Track Length (m)</label>
              <input
                type="number"
                className="form-control"
                name="track_length"
                value={userFormSettings?.track_length || 2500}
                onChange={handleAccountChange}
                placeholder="2500"
              />
            </div>

            <div className="form-group my-3">
              <label htmlFor="manual_lap_mode">Lap Increments by Distance</label>
              <select
                className="form-control"
                name="manual_lap_mode"
                value={userFormSettings?.manual_lap_mode || 'false'}
                onChange={handleAccountChange}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <button className="btn btn-danger btn-block" type="button" onClick={clearRealtimeDatabase}>Reset Recorded Data</button>
          </div>
        </form>
      </div>
    </>
  )
}